import { render, staticRenderFns } from "./Highlights.vue?vue&type=template&id=ed3f5e40&scoped=true&"
import script from "./Highlights.vue?vue&type=script&lang=ts&"
export * from "./Highlights.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3f5e40",
  null
  
)

export default component.exports